// @flow

import * as React from 'react';

import { Radio, Base } from '@gandi/ui';

export type Option = {
  value: string,
  content: string,
  help: string,
  defaultChecked?: boolean,
};

export type RadioOptionProps = {
  option: Option,
  index: number,
  handler: (SyntheticInputEvent<>) => void,
};

export default class RadioOption extends React.Component<RadioOptionProps> {
  render(): React.Node {
    return (
      <>
        <Radio
          defaultChecked={this.props.index === 0}
          id={`radio-${this.props.index}`}
          key={`radio-${this.props.option.value}`}
          marginBottom="xsmall"
          name="wizard-selection-screen-radio"
          value={this.props.option.value}
          onChange={this.props.handler}
        >
          {this.props.option.content}
        </Radio>
        <Base
          key={`radio-help-${this.props.option.value}`}
          tagName="p"
          color="light"
          marginTop="none"
          marginBottom="xsmall"
          style={{ paddingLeft: '2.267em' }}
        >
          {this.props.option.help}
        </Base>
      </>
    );
  }
}
